import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

/**
 * Feature launches — the live window is stored in UTC (2026-10-27). The admin picks a local
 * time; the API gets that instant in UTC; the dashboard compares it with UTC_TIMESTAMP(). The
 * CMS pool reads DATETIME as UTC (timezone '+00:00'), so a stored value comes back as an ISO
 * string ending in Z — or as a plain "YYYY-MM-DD HH:mm:ss", which is UTC too.
 */

const API_FORMAT = "YYYY-MM-DD HH:mm:ss";

/** A picked dayjs (local) → the UTC string the API stores; null stays null. */
export const toApiDate = (d) => (d ? d.utc().format(API_FORMAT) : null);

/** A stored UTC value → a local dayjs for the picker and the list; null stays null. */
export const fromApiDate = (v) => {
  if (!v) return null;
  const s = String(v);
  return /[zZ]|[+-]\d{2}:\d{2}$/.test(s) ? dayjs(s) : dayjs.utc(s).local();
};

/** For text placed inside a SweetAlert `html` message. */
export const escapeHtml = (s) =>
  String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);
